import React from "react";
import { IconButton, Tooltip, useTheme } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import useStyles from "./styles";
import { ApprovalAction } from "Shared/types/ApprovalActions";
import pretty from "Shared/pretty";

export interface ApprovalActionButtonProps {
  action: ApprovalAction;
  onActionButtonClick: () => void;
}

export const ApprovalActionButton = ({
  action,
  onActionButtonClick
}: ApprovalActionButtonProps) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Tooltip
      title={pretty.titleizeWord(action)}
      classes={{
        tooltip: classes.tooltip,
      }}
    >
      <IconButton
        className={classes.button}
        onClick={() => onActionButtonClick()}
      >
        {action === ApprovalAction.approve
          ? <CheckCircleIcon style={{ color: theme.palette.success.main }} />
          : <CancelIcon color="error" />
        }
      </IconButton>
    </Tooltip>
  );
};
